export enum ActiveFilter {
  INACTIVE,
  AVAILABILITY,
  SEARCH,
}
